import React, { useState } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from 'v2/models';
import { PERMISSION_NAME, hasPermission } from 'v2/utils/permissions';
import { searchViewPath } from 'v2/utils/searchViewUtils';
import clipIcon from 'v2/icons/clip.svg';
import styles from './linkEntity.module.scss';
import LinkEntityModal from './LinkEntityModal';
import { useLocation } from 'react-router-dom';

interface LinkEntityProps {
  comingFromPath?: string;
  searchId: number;
}

interface LocationStateType {
  linkEntityModalOpen?: boolean;
}

const LinkEntity = ({ comingFromPath, searchId }: LinkEntityProps) => {
  const linkEntityModalOpen =
    useLocation<LocationStateType>().state?.linkEntityModalOpen;
  const modalInitialState = linkEntityModalOpen ? true : false;
  const [showModal, setShowModal] = useState(modalInitialState);
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );

  const isReviewer = hasPermission(permissions, [
    PERMISSION_NAME.REVIEW_SEARCH_MASTER_ORG,
    PERMISSION_NAME.REVIEW_SEARCH_ORG,
  ]);
  const isDRM = hasPermission(permissions, [PERMISSION_NAME.DRM]);

  if (
    !isReviewer ||
    !isDRM ||
    !comingFromPath ||
    !comingFromPath.includes(searchViewPath.forReview)
  ) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className={classnames(
          'mr-2',
          'btn-secondary-dark',
          'btn btn-secondary',
          styles.linkEntityBtn
        )}
      >
        <img src={clipIcon} alt={'linkEntityIcon'} className={'pr-2'}></img>
        <span>Link entity</span>
      </button>
      {showModal && (
        <LinkEntityModal
          searchId={searchId}
          show={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default LinkEntity;
